module.exports = __webpack_public_path__ + "img/icon (1).b20509ac.png";